import type { TrackingEvent } from '@marketplace-web/observability/event-tracker-data'
import { Screen } from 'constants/tracking/screens'

export enum ReasonForNotBundling {
  ShippingSize = 'shipping_size_mismatch',
}

type CannotBundleButtonViewEventArgs = {
  listingId: string | number | null
  sellerId: string | number | null
  reasonForNotBundling: ReasonForNotBundling
  screen: string | null
  bundleSessionId: string | null
}

type CannotBundleButtonViewEventExtra = {
  listing_id: string | number | null
  seller_id: string | number | null
  reason_for_not_bundling: ReasonForNotBundling
  screen: string | null
  bundle_session_id: string | null
}

export const cannotBundleButtonViewEvent = (
  args: CannotBundleButtonViewEventArgs,
): TrackingEvent => {
  const { listingId, sellerId, reasonForNotBundling, screen, bundleSessionId } = args
  const extra: CannotBundleButtonViewEventExtra = {
    listing_id: listingId,
    seller_id: sellerId,
    reason_for_not_bundling: reasonForNotBundling,
    screen,
    bundle_session_id: bundleSessionId,
  }

  return {
    event: 'bundles.cannot_bundle_button_view',
    extra,
  }
}

type CannotBundleButtonClickEventArgs = {
  listingId: string | number | null
  sellerId: string | number | null
  reasonForNotBundling: ReasonForNotBundling
  screen: string | null
  bundleSessionId: string | null
}

type CannotBundleButtonClickEventExtra = {
  listing_id: string | number | null
  seller_id: string | number | null
  reason_for_not_bundling: ReasonForNotBundling
  screen: string | null
  bundle_session_id: string | null
}

export const cannotBundleButtonClickEvent = (
  args: CannotBundleButtonClickEventArgs,
): TrackingEvent => {
  const { listingId, sellerId, reasonForNotBundling, screen, bundleSessionId } = args
  const extra: CannotBundleButtonClickEventExtra = {
    listing_id: listingId,
    seller_id: sellerId,
    reason_for_not_bundling: reasonForNotBundling,
    screen,
    bundle_session_id: bundleSessionId,
  }

  return {
    event: 'bundles.cannot_bundle_button_click',
    extra,
  }
}

type CannotBundleHyperlinkClickEventArgs = {
  listingId: string | number | null
  sellerId: string | number | null
  reasonForNotBundling: ReasonForNotBundling
  screen: string | null
  bundleSessionId: string | null
}

type CannotBundleHyperlinkClickEventExtra = {
  listing_id: string | number | null
  seller_id: string | number | null
  reason_for_not_bundling: ReasonForNotBundling
  screen: string | null
  bundle_session_id: string | null
}

export const cannotBundleHyperlinkClickEvent = (
  args: CannotBundleHyperlinkClickEventArgs,
): TrackingEvent => {
  const { listingId, sellerId, reasonForNotBundling, screen, bundleSessionId } = args
  const extra: CannotBundleHyperlinkClickEventExtra = {
    listing_id: listingId,
    seller_id: sellerId,
    reason_for_not_bundling: reasonForNotBundling,
    screen,
    bundle_session_id: bundleSessionId,
  }

  return {
    event: 'bundles.cannot_bundle_hyperlink_click',
    extra,
  }
}

type ClickBundleDiscountSuggestionEventExtra = {
  discounts_enabled: boolean
  screen: Screen
}

type ClickBundleDiscountSuggestionEventArgs = {
  discountsEnabled: boolean
  screen: Screen
}

export const clickBundleDiscountSuggestionEvent = (
  args: ClickBundleDiscountSuggestionEventArgs,
): TrackingEvent => {
  const { discountsEnabled, screen } = args

  const extra: ClickBundleDiscountSuggestionEventExtra = {
    discounts_enabled: discountsEnabled,
    screen,
  }

  return {
    event: 'user.bundle_discount_settings_click',
    extra,
  }
}

type ClickBundleDiscountEnableEventExtra = {
  enable_discount: boolean
  screen: Screen
}

type ClickBundleDiscountEnableEventArgs = {
  enableDiscount: boolean
  screen: Screen
}

export const clickBundleDiscountEnableEvent = (
  args: ClickBundleDiscountEnableEventArgs,
): TrackingEvent => {
  const { enableDiscount, screen } = args

  const extra: ClickBundleDiscountEnableEventExtra = {
    enable_discount: enableDiscount,
    screen,
  }

  return {
    event: 'user.bundle_discount_enable',
    extra,
  }
}

type CloseBundleDiscountScreenEventExtra = {
  discount_2_items: number | null
  discount_3_items: number | null
  discount_5_items: number | null
  screen: Screen
}

type CloseBundleDiscountScreenEventArgs = {
  discount2Items: number | null
  discount3Items: number | null
  discount5Items: number | null
  screen: Screen
}

export const closeBundleDiscountScreenEvent = (
  args: CloseBundleDiscountScreenEventArgs,
): TrackingEvent => {
  const { discount2Items, discount3Items, discount5Items, screen } = args

  const extra: CloseBundleDiscountScreenEventExtra = {
    discount_2_items: discount2Items,
    discount_3_items: discount3Items,
    discount_5_items: discount5Items,
    screen,
  }

  return {
    event: 'user.bundle_discount_amount',
    extra,
  }
}
